import {NavBar} from "../../organisms/NavBar/NavBar";
import {Button, Typography, Box, useTheme} from "@mui/material";

export const AboutPage = () => {
    const theme = useTheme()

    return (
        <>
        <NavBar />
            <Box maxWidth={1200} mx={'auto'} color={theme.palette.grey[800]} pb={4}>
                <Typography
                    component="p"
                    variant="h5"
                    align="center"
                    width={'100%'}
                    color={theme.palette.grey[500]}
                    fontWeight={100}
                    pl={3.5}
                    pr={3.5}
                    mt={3}
                    mb={1}
                    >
                    About Trend-spotting
                </Typography>
                <Box marginRight='auto' marginLeft='auto'>
                    <Typography
                        component="p"
                        variant="body1"
                        align="left"
                        pl={3.5}
                        pr={3.5}
                    >
                        We've all read the messages from the touts. <i>I'm 8-2 with my last 10 Bookie Ballbuster 5-dime Whale plays. </i>
                        Reject the salesmen and reject the gut feelings. Trend-spotting empowers you to find real edges.
                    <br/>
                    <br/>
                        Trend-spotting is an <a href="https://sdql.com/basics.html">SDQL</a>-powered web application designed to streamline research of situational against-the-spread and over-under performance data in games that are available to wager.
                        Bettors can utilize the query interface or trend-finder to identify profitable betting spots, save their analyses, and track when their trends become relevant.
                        Saved trends are executed against the SDQL database daily to determine if they are active for upcoming games.
                        <br/>
                        <Typography
                            component="p"
                            variant="h5"
                            align="center"
                            width={'100%'}
                            color={theme.palette.grey[500]}
                            fontWeight={100}
                            pl={3.5}
                            pr={3.5}
                            mt={2}
                            mb={1}
                        >
                            Record Keeping
                        </Typography>
                        We are not a pick-selling website, but we do offer selections highlighting the power of the software, and to provide users
                        with tutorials on using the query interface and trend-finder. Our documented record is kept <a href='https://betstamp.com/app/u/trend-spotting'>here</a>.
                        <Typography
                            component="p"
                            variant="h5"
                            align="center"
                            width={'100%'}
                            color={theme.palette.grey[500]}
                            fontWeight={100}
                            pl={3.5}
                            pr={3.5}
                            mt={2}
                            mb={1}
                        >
                            Registration
                        </Typography>
                    Upon registering as a trend-spotter, you will receive ~50 free default trends. They are simple, league-wide trends that should
                    nudge you toward sides or totals where there is a situational edge. Users are encouraged to perform their
                    own research for active trend games using trend-finder and the query interface.
                    <br/>
                    <br/>
                    Trend-spotters can save an additional 25 custom trends, which will be checked against upcoming schedules daily
                    to determine if they are active. Users can delete and add new custom trends at any time.
                        <Typography
                            component="p"
                            variant="h5"
                            align="center"
                            width={'100%'}
                            color={theme.palette.grey[500]}
                            fontWeight={100}
                            pl={3.5}
                            pr={3.5}
                            mt={2}
                            mb={1}
                        >
                            Trend-finder
                        </Typography>
                        The trend-finder tool is a simple interface for querying common conditions like home/away and favorite/underdog without the need to manually type each clause into a text field.
                        By selecting a game from the matchups table, trend-finder will open displaying trends that are relevant to the selected game's properties. You can also select the "trend-finder" link to perform generic research,
                        without a specific game in mind.
                        <br/>
                        <br/>
                        Novice users can leverage trend-finder to build their SDQL skills, gaining insight into how combining condition clauses influences the data displayed in the
                        tables below. Once familiarized with the parameter-operator-value syntax of SDQL, users can begin to
                        write and save their own custom SDQL queries.
                </Typography>
            </Box>
            </Box>
        </>
    )
}